import { render } from "./currencies-settings.vue?vue&type=template&id=067abeae"
import script from "./currencies-settings.vue?vue&type=script&lang=js"
export * from "./currencies-settings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__